import { render, staticRenderFns } from "./EtapaDadosContato.vue?vue&type=template&id=0ca98f8b"
import script from "./EtapaDadosContato.vue?vue&type=script&lang=js"
export * from "./EtapaDadosContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports